import React from 'react';

import AutoCompleteTextBox from './AutoCompleteTextBox';
import TextBox from './TextBox';
import { useFormSelector } from '../../../custom-hooks';
import { FORM_MODEL_ATTRIBUTES } from '../../constants/form-manager.constants';
import { LOOKUP_TYPES } from '../../constants/runtime.constants';
import { getEvaluatedConditions } from '../../selectors/form-manager.selectors';
import { hasVisibleZoomControl } from '../../selectors/runtime.selectors';

const SSTextBox = (props) => {
  const { id, lookupType, index, entityName } = props;

  const hasZoom = useFormSelector(hasVisibleZoomControl, { id, index, entityName });
  const isDisabledWithZoom = useFormSelector(getEvaluatedConditions, {
    id,
    index,
    entityName,
    prop: FORM_MODEL_ATTRIBUTES.DISABLED_WITH_ZOOM,
  });

  if (lookupType === LOOKUP_TYPES.AUTOCOMPLETE && hasZoom) {
    return <AutoCompleteTextBox {...props} isDisabledWithZoom={isDisabledWithZoom} />;
  }

  return <TextBox {...props} isDisabledWithZoom={isDisabledWithZoom} />;
};

export default SSTextBox;
